//==========import components===============
import SubPagesLayout from 'layouts/SubPagesLayout';
import ServiceListing from 'components/services/ServiceListing';
import { serviceListData } from 'helpers/servicesHelper';

const ServicePage = () => {
  return (
    <div className='DBlock servicePage'>
      <ServiceListing data={serviceListData} />
    </div>
  );
};

export default SubPagesLayout({ route: 'Home/Services' })(ServicePage);
